export default {
  login: {
    welcome: 'С возвращением',
    subtitle: 'Войдите, чтобы продолжить покупки',
    phonePlaceholder: 'Введите номер телефона',
    passwordPlaceholder: 'Введите пароль',
    showPassword: 'Показать',
    hidePassword: 'Скрыть',
    loginButton: 'Войти',
    registerButton: 'Бесплатная регистрация',
    title: 'Войти',
    subtitle2: 'Глобальные покупки в одном месте для получения вознаграждений',
    logging: 'Вход...',
    phoneRequired: 'Введите номер телефона',
    passwordRequired: 'Введите пароль',
    loginSuccess: 'Вход выполнен успешно',
    loginFailed: 'Ошибка входа',
    loginError: 'Ошибка входа, попробуйте позже'
  },
  register: {
    title: 'Создать аккаунт',
    subtitle: 'Присоединяйтесь к нам и начните свою торговую поездку',
    username: 'Имя пользователя',
    phone: 'Номер телефона',
    loginPassword: 'Пароль для входа',
    transactionPassword: 'Пароль транзакции',
    invitationCode: 'Код приглашения',
    usernamePlaceholder: 'Введите имя пользователя',
    phonePlaceholder: 'Введите номер телефона',
    loginPasswordPlaceholder: 'Введите пароль для входа',
    transactionPasswordPlaceholder: 'Введите пароль транзакции',
    invitationCodePlaceholder: 'Введите код приглашения',
    registerButton: 'Зарегистрироваться',
    hasAccount: 'Уже есть аккаунт? Войти',
    errorUsername: 'Введите имя пользователя',
    errorPhone: 'Введите номер телефона',
    errorLoginPassword: 'Введите пароль для входа',
    errorTransactionPassword: 'Введите пароль транзакции',
    errorInviteCode: 'Введите код приглашения',
    registerSuccess: 'Регистрация успешна'
  },
  tabbar: {
    home: 'Главная',
    purchase: 'История заказов',
    grabbing: 'Заказать',
    kefu: 'Служба поддержки',
    my: 'Мой'
  },
  home: {
    orderCount: 'Количество заказов',
    upgradeAmount: 'Пополнить и обновить',
    recharge: 'Пополнить',
    withdraw: 'Вывести',
    team: 'Управление командой',
    commission: 'Получить комиссию',
    newProducts: 'Новые продукты',
    newProductsDesc: 'Последние стили нового сезона и будущие коллекции.',
    buyNow: 'Купить сейчас',
    nowAvailable: 'Доступно сейчас',
    nowAvailableDesc: 'Подготовьтесь к свадебному сезону, соберите вещи для следующей поездки и обновите свой гардероб без обязательств. С нашим новым планом аренды вы можете попробовать последние тенденции и оставаться в рамках своего бюджета без подписки.',
    footerTitle: 'Desigual.com',
    footerFollow: "Подпишитесь на нас {'@'}Desigual.com и поделитесь своими любимыми образами Desigual.com!",
    footerShop: 'Просмотрите наш каталог'
  },
  purchase: {
    all: 'Все',
    pending: 'В ожидании',
    completed: 'Завершено',
    frozen: 'Заморожено',
    balance: 'Баланс счета',
    orderTime: 'Время заказа',
    orderId: 'Номер заказа',
    totalAmount: 'Общая сумма заказа',
    commission: 'Комиссия',
    expectedReturn: 'Ожидаемый возврат',
    submitOrder: 'Отправить заказ',
    orderCompleted: 'Заказ завершен',
    loading: 'Загрузка...',
    noData: 'Нет данных о заказах',
    noMore: 'Больше нет',
    orderSuccess: 'Заказ успешен',
    orderNumber: 'Номер заказа',
    rating: 'Оценка',
    notSubmit: 'Не отправлять сейчас',
    submitNow: 'Отправить сейчас',
    submitting: 'Отправка...',
    submitFailed: 'Ошибка отправки',
    grabOrderFailed: 'Ошибка получения заказа, попробуйте позже',
    getOrderInfoFailed: 'Ошибка получения деталей заказа',
    submitOrderFailed: 'Ошибка отправки, попробуйте позже'
  },
  common: {
    home: 'Главная',
    about: 'О нас',
    contact: 'Связаться с нами',
    purchase: 'История заказов',
    grabbing: 'Заказать',
    my: 'Мой',
    login: 'Войти',
    register: 'Зарегистрироваться',
    kefu: 'Служба поддержки',
    loadDataError: 'Ошибка загрузки данных, попробуйте позже',
    success: 'Операция успешна',
    failed: 'Операция не удалась',
    submitSuccess: 'Отправка успешна',
    submitFailed: 'Ошибка отправки',
    submitting: 'Отправка...'
  },
  grabbing: {
    accountAmount: 'Сумма счета',
    accountBalance: 'Баланс счета',
    getCommission: 'Получить комиссию',
    ordersGrabbedToday: 'Заказов получено сегодня',
    orderCount: 'Количество заказов',
    operationSteps: 'Этапы операции',
    step1: '1. Нажмите кнопку Начать задачу и выполните задачу согласно инструкциям',
    step2: '2. После завершения задачи вы можете выплатить комиссию на баланс',
    grabOrder: 'Получить заказ',
    pleaseWait: 'Пожалуйста, подождите',
    grabSuccess: 'Заказ успешен',
    grabTime: 'Время заказа',
    grabNumber: 'Номер заказа',
    orderTotal: 'Общая сумма заказа',
    commission: 'Комиссия',
    expectedReturn: 'Ожидаемый возврат',
    rating: 'Оценка',
    notSubmit: 'Не отправлять сейчас',
    submitNow: 'Отправить сейчас',
    submitting: 'Отправка...'
  },
  kefu: {
    title: 'Служба поддержки',
    intro: {
      line1: 'Если у вас есть вопросы или нужна помощь,',
      line2: 'свяжитесь со службой поддержки для решения'
    },
    serviceTime: {
      label: 'Время работы',
      text: 'Ваша эксклюзивная служба поддержки',
      online: 'Онлайн'
    },
    contact: {
      title: 'Контакт',
      name: 'Онлайн',
      status: 'Консультация',
      feature1: 'Мгновенный ответ',
      feature2: 'Профессиональная служба',
      button: 'Связаться'
    },
    faq: {
      title: 'Часто задаваемые вопросы',
      rechargeQuestion: 'Как пополнить?',
      rechargeAnswer: 'Вы можете пополнить через наш безопасный платежный шлюз. Перейдите в Мой аккаунт > Пополнить и следуйте инструкциям.',
      withdrawQuestion: 'Как вывести?',
      withdrawAnswer: 'Вывод можно сделать через Мой аккаунт > Вывести. Убедитесь, что ваш аккаунт проверен.',
      minRechargeQuestion: 'Какая минимальная сумма пополнения?',
      minRechargeAnswer: 'Минимальная сумма пополнения составляет ${currency}68.',
      withdrawTimeQuestion: 'Сколько времени занимает вывод?',
      withdrawTimeAnswer: 'Вывод обычно обрабатывается в течение 24 часов.',
      securityQuestion: 'Безопасна ли моя информация?',
      securityAnswer: 'Да, мы используем стандартную технологию шифрования для защиты вашей личной и финансовой информации.'
    }
  },
  my: {
    inviteCode: 'Код приглашения',
    copy: 'Копировать',
    copySuccess: 'Копирование успешно',
    copyFailed: 'Ошибка копирования',
    online: 'Онлайн',
    accountAmount: 'Сумма счета',
    balance: 'Баланс счета',
    accountBalanceTrend: 'Баланс счета',
    todayCommission: 'Комиссия сегодня',
    totalCommission: 'Общая комиссия',
    today: 'Сегодня',
    total: 'Всего',
    todayOrders: 'Заказов получено сегодня',
    orderCount: 'Количество заказов',
    recharge: 'Пополнить',
    withdraw: 'Вывести',
    rechargeRecord: 'История пополнений',
    withdrawRecord: 'История выводов',
    accountDetails: 'Детали счета',
    receivingAccount: 'Счет для получения',
    bankAccount: 'Банковский счет',
    bankAccountDesc: 'Банковский счет',
    usdt: 'USDT',
    usdtDesc: 'Адрес USDT',
    connect: 'Подключить',
    teamManagement: 'Управление командой',
    viewTeam: 'Просмотреть команду',
    changePassword: 'Изменить пароль',
    changeWithdrawPassword: 'Изменить пароль вывода',
    passwordSettings: 'Настройки пароля',
    logout: 'Выйти',
    signOut: 'Выйти',
    version: 'Версия'
  },
  changePasswordPage: {
    currentPassword: 'Текущий пароль входа',
    currentPasswordPlaceholder: 'Введите текущий пароль',
    newPassword: 'Новый пароль входа',
    newPasswordPlaceholder: 'Введите новый пароль',
    confirmPassword: 'Подтвердить пароль входа',
    confirmPasswordPlaceholder: 'Подтвердите новый пароль',
    notice: 'Пароль входа используется для доступа к аккаунту. Пароль должен содержать не менее 6 символов и включать буквы и цифры для обеспечения безопасности.',
    updateButton: 'Обновить пароль входа',
    errorOldPassword: 'Введите текущий пароль',
    errorNewPassword: 'Введите новый пароль',
    errorConfirmPassword: 'Подтвердите новый пароль',
    errorPasswordMismatch: 'Пароли не совпадают',
    errorPasswordLength: 'Пароль должен содержать не менее 6 символов',
    errorPasswordFormat: 'Пароль должен содержать буквы и цифры'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'Текущий пароль вывода',
    currentPasswordPlaceholder: 'Введите текущий пароль вывода',
    newPassword: 'Новый пароль вывода',
    newPasswordPlaceholder: 'Введите новый пароль вывода',
    confirmPassword: 'Подтвердить пароль вывода',
    confirmPasswordPlaceholder: 'Подтвердите новый пароль вывода',
    notice: 'Пароль вывода используется для операций вывода средств. Пароль должен содержать не менее 6 символов и включать буквы и цифры для обеспечения безопасности.',
    updateButton: 'Обновить пароль вывода',
    errorOldPassword: 'Введите текущий пароль вывода',
    errorNewPassword: 'Введите новый пароль вывода',
    errorConfirmPassword: 'Подтвердите новый пароль вывода',
    errorPasswordMismatch: 'Пароли не совпадают',
    errorPasswordLength: 'Пароль должен содержать не менее 6 символов',
    errorPasswordFormat: 'Пароль должен содержать буквы и цифры'
  },
  details: {
    loading: 'Загрузка...',
    noRecords: 'Нет записей',
    noMore: 'Больше нет',
    time: 'Время',
    type: 'Тип',
    amount: 'Сумма',
    balance: 'Баланс',
    remark: 'Примечание',
    type0: 'Другое',
    type1: 'Пополнение',
    type2: 'Вывод',
    type3: 'Транзакция',
    type4: 'Комиссия заказа',
    type5: 'Комиссия подчиненного',
    type8: 'Вывод отклонен'
  },
  rechargeRecord: {
    offline: 'Оффлайн пополнение',
    online: 'Онлайн пополнение',
    loading: 'Загрузка...',
    noRecords: 'Нет записей',
    orderNo: 'Номер заказа',
    rechargeAmount: 'Сумма пополнения',
    rechargeTime: 'Время пополнения',
    payMethod: 'Способ оплаты',
    rechargeStatus: 'Статус пополнения',
    noMore: 'Больше нет',
    statusPending: 'Ожидает одобрения',
    statusApproved: 'Одобрено',
    statusFailed: 'Ошибка',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'Загрузка...',
    noRecords: 'Нет записей',
    orderNo: 'Номер заказа',
    withdrawAmount: 'Сумма вывода',
    withdrawTime: 'Время вывода',
    withdrawAddress: 'Адрес вывода',
    withdrawStatus: 'Статус вывода',
    noMore: 'Больше нет',
    statusPending: 'Обработка',
    statusApproved: 'Успешно',
    statusFailed: 'Ошибка',
    statusEmpty: ''
  },
  withdraw: {
    title: 'Вывести',
    method: 'Способ вывода',
    methodSubtitle: 'Выберите способ вывода',
    bankInfo: 'Информация о банковском счете',
    bankName: 'Банк',
    accountHolder: 'Имя владельца',
    bankCard: 'Банковская карта',
    amount: 'Сумма вывода',
    balance: 'Баланс',
    withdrawAll: 'Вывести все',
    paymentPassword: 'Пароль оплаты',
    passwordPlaceholder: 'Введите пароль средств',
    principal: 'Основная сумма',
    serviceFee: 'Комиссия за обслуживание',
    netAmount: 'Чистая сумма',
    notice: '*Тщательно проверьте информацию о получении',
    withdrawButton: 'Вывести',
    walletAddress: 'Адрес кошелька',
    walletAddressSubtitle: 'Введите адрес кошелька'
  },
  recharge: {
    title: 'Пополнить',
    amount: 'Сумма пополнения',
    amountSubtitle: 'Введите сумму, которую хотите пополнить',
    quickSelect: 'Быстрый выбор',
    rechargeNow: 'Пополнить сейчас',
    selectPayment: 'Выбрать способ оплаты',
    selectPaymentSubtitle: 'Выберите предпочитаемый способ оплаты',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    crypto: 'Криптовалюта',
    bank: 'Банковский перевод',
    paymentRange: 'Минимум: {symbol}{minAmount} - Максимум: {symbol}{maxAmount}',
    rechargeFailed: 'Ошибка пополнения',
    paymentInfo: 'Информация о платеже',
    usercode: 'Адрес USDT',
    uploadScreenshot: 'Пожалуйста, загрузите скриншот платежа',
    clickToUpload: 'Нажмите, чтобы загрузить скриншот',
    copySuccess: 'Скопировано успешно',
    copyFailed: 'Ошибка копирования',
    uploadScreenshotRequired: 'Пожалуйста, загрузите скриншот платежа',
    submit: 'Отправить',
    submitting: 'Отправка...',
    submitSuccess: 'Успешно отправлено',
    submitFailed: 'Ошибка отправки'
  },
  bindUsdt: {
    title: 'Привязать USDT',
    cardTitle: 'Адрес USDT',
    cardSubtitle: 'Введите адрес вашего кошелька USDT',
    walletAddress: 'Адрес кошелька',
    walletAddressPlaceholder: 'Введите адрес кошелька USDT',
    networkType: 'Тип сети',
    networkTypePlaceholder: 'Выберите тип сети',
    withdrawPassword: 'Пароль вывода',
    withdrawPasswordPlaceholder: 'Введите пароль вывода',
    trc20: 'TRC20',
    trc20Network: 'Сеть TRC20',
    erc20: 'ERC20',
    erc20Network: 'Сеть ERC20',
    securityNotice: 'Уведомление о безопасности',
    securityText1: '• Ваш адрес USDT зашифрован и безопасно хранится',
    securityText2: '• Только вы можете просматривать и изменять эту информацию',
    securityText3: '• Убедитесь, что вся информация точна',
    buttonText: 'Сохранить информацию',
    buttonSubtitle: 'Привязать адрес USDT',
    errorWalletAddress: 'Введите адрес кошелька',
    errorNetworkType: 'Выберите тип сети',
    errorWithdrawPassword: 'Введите пароль вывода'
  },
  team: {
    title: 'Управление командой',
    level1: 'Команда уровня 1',
    level2: 'Команда уровня 2',
    level3: 'Команда уровня 3',
    level1Members: 'Члены команды уровня 1',
    level2Members: 'Члены команды уровня 2',
    level3Members: 'Члены команды уровня 3',
    totalMembers: 'Всего членов',
    totalCommission: 'Общая комиссия',
    members: 'человек',
    orders: 'Заказы',
    commission: 'Комиссия',
    noMembers: 'Нет членов',
    loading: 'Загрузка...',
    noMore: 'Больше нет'
  },
  bindBank: {
    title: 'Привязать банковскую карту',
    cardTitle: 'Банковская информация',
    cardSubtitle: 'Выберите ваш банк и введите детали счета',
    bankName: 'Банк',
    bankNamePlaceholder: 'Введите название банка',
    cardNumber: 'Номер карты',
    cardNumberPlaceholder: 'Введите номер карты',
    realName: 'Настоящее имя',
    realNamePlaceholder: 'Введите настоящее имя',
    withdrawPassword: 'Пароль вывода',
    withdrawPasswordPlaceholder: 'Введите пароль вывода',
    securityNotice: 'Уведомление о безопасности',
    securityText1: '• Ваша банковская информация зашифрована и безопасно хранится',
    securityText2: '• Только вы можете просматривать и изменять эту информацию',
    securityText3: '• Убедитесь, что вся информация точна',
    buttonText: 'Сохранить информацию',
    buttonSubtitle: 'Привязать банковский счет',
    errorBankName: 'Введите название банка',
    errorCardNumber: 'Введите номер карты',
    errorRealName: 'Введите настоящее имя',
    errorWithdrawPassword: 'Введите пароль вывода'
  }
}
